<template>
  <div class="dropdown m-0 p-0">
    <button
      type="button"
      :id="id"
      class="btn dropdown-toggle"
      :class="[size ? `btn-${size}` : null, color ? `btn-${color}` : null]"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <slot name="label">
        {{ label }}
      </slot>
    </button>
    <ul class="dropdown-menu">
      <slot name="item" v-for="(item, idx) in items" :key="idx" :item="item">
        <li>
          <a
            class="dropdown-item"
            href="#"
            @click="() => $emit('click', item)"
            >{{ item.label || item.name }}</a
          >
        </li>
      </slot>
    </ul>
  </div>
</template>

<script>
export default {
  name: "AlzataDropdown",
  props: {
    id: String,
    label: String,
    size: String,
    color: String,
    style: {
      type: String,
      default: "secondary",
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
